import { useTranslation } from 'react-i18next';

import {
    Body2,
    FilledCard,
    Stack,
    Subtitle1,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

import type { PricingComponentProps } from './pricing-types';

export const FallbackPricing = ({ price }: PricingComponentProps) => {
    const { t } = useTranslation('lilly');

    return (
        <>
            <FilledCard
                withBorder
                color="primary"
                data-testid="pharmacy-pricing-card"
            >
                <Stack>
                    {price === null ? (
                        <Subtitle2>
                            {t('fill.fallback.pricing.finalPriceAtPharmacy')}
                        </Subtitle2>
                    ) : (
                        <>
                            <Subtitle1>
                                {t('fill.fallback.pricing.listPrice', {
                                    price,
                                })}
                            </Subtitle1>
                            <Body2>
                                {t(
                                    'fill.fallback.pricing.finalPriceAtPharmacy'
                                )}
                            </Body2>
                        </>
                    )}
                </Stack>
            </FilledCard>
            {price !== null && (
                <Stack data-testid="pharmacy-pricing-terms-and-conditions">
                    <Body2>
                        {t('fill.pricing.feesMayApply', {
                            termsDisclaimer: '',
                        })}
                    </Body2>
                </Stack>
            )}
        </>
    );
};
